/*
 * @Author: Teemo Ding
 * @Date: 2021-10-14 10:59:09
 * @LastEditTime: 2021-10-18 14:28:44
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/hooks.ts
 */
import {
  useSalesChannelType,
  useSalesChannel,
} from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { getConfig } from '@/src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { LinkModuleType } from '@/src/types/common/linkType';
// import { SalesChannelModeWithSister } from '@/src/types/common/SalesChannel';
import { get } from 'lodash';
import { SalesChannelMode } from 'src/types/common/SalesChannel';

//import { LinkModuleType } from 'src/types/common/linkType';
const homepageUuid = 'cf93058f-7a36-48c0-a825-285086cd3ff5';
const allProductsUuid = '69f8082a-1511-4f68-bb3d-3d7276001704';
const cartUuid = '0e4c66fc-f882-4bea-bbce-f5ab811241a9';
const profileUuid = 'b6ccd975-d2e6-46e9-a284-501313e9b54f';
const customerServiceUuid = '7c0b1c58-abe7-47a0-809e-fa8d46812dce';
const shareMiniProgramUuid = 'f9d2352d-2c06-4e86-8311-5520d95c5285';

const infoSiteLinkType = [
  LinkModuleType.None,
  LinkModuleType.HomePage,
  LinkModuleType.ContentPage,
  LinkModuleType.LegalPage,
  LinkModuleType.LinkLibrary,
];

const checkIsInternal = (linkType, uuid) => {
  if (linkType === LinkModuleType.SysModule) {
    return [
      homepageUuid,
      allProductsUuid,
      cartUuid,
      profileUuid,
      customerServiceUuid,
    ].includes(uuid);
  }
  return [
    LinkModuleType.None,
    LinkModuleType.Product,
    LinkModuleType.Collection,
    LinkModuleType.ContentPage,
    LinkModuleType.LegalPage,
  ].includes(linkType);
};

const _list = () => {
  return useSelector(getConfig()) || [];
};
//For general sales channel content,
const useSalesChannelGeneralLinkSet = ({ contentUuid }) => {
  let list = _list();
  list = list.filter((i) => {
    return i.uuid !== shareMiniProgramUuid;
  });
  return {
    selectedLinkType: list,
    scopeVariables: {
      SalesChannelContent: contentUuid,
    },
  };
};
const useSalesChannelProductLinkSet = ({ salesChannelUuid }) => {
  let list = _list();
  list = list.filter((i) => {
    return i.linkType !== LinkModuleType.ShareMiniProgram;
  });
  return {
    linkTypeFilter: list, //无用，实际只用到了scopeVariables 和 各个使用处的exclude
    scopeVariables: {
      SalesChannel: salesChannelUuid,
      SalesChannelOuterContent: salesChannelUuid,
    },
  };
};

//For sales channel action bar
const useSalesChannelMiniProgramLinkSet = ({ contentUuid }) => {
  const channelType = useSalesChannelType();
  //const channelType = get(salesChannel, 'channelType');
  let list = _list();

  if (channelType === ChannelType.MiniProgram) {
  }
  if (channelType === ChannelType.Website) {
    list = list.filter((i) => {
      return i.uuid !== shareMiniProgramUuid;
    });
  }

  return {
    selectedLinkType: list,
    scopeVariables: {
      SalesChannelContent: contentUuid,
    },
  };
};

const useContentVersionLinkModuleWithSalesChannelMode = ({
  // salesChannelMode,
  salesChannelContentUuid,
  selectedSalesChannelUuid,
  salesChannelUuid,
  presetLinkTypeFilter, //for content version linkset only
  presetExcludeLinkType, //for sales channel linkset only
  presetScopeVariables,
}: //customLinkTypeObject, //for sales channel linkset only now
{
  selectedSalesChannelUuid: string;
  salesChannelContentUuid?: string;
  salesChannelUuid?: string;
  presetLinkTypeFilter?: LinkModuleType[];
  presetScopeVariables?: any;
  customLinkTypeObject?: any;
  presetExcludeLinkType?: any;
}) => {
  const currentSalesChannel = useSalesChannel();
  const currentUuid = get(currentSalesChannel, 'uuid');
  const selectedUuid = selectedSalesChannelUuid || currentUuid;

  const salesChannelMode = get(currentSalesChannel, 'siteMode');
  const sisterSalesChannel = get(currentSalesChannel, 'sisterSalesChannel');
  const sisterMode = get(sisterSalesChannel, 'siteMode');
  const sisterUuid = get(sisterSalesChannel, 'uuid');
  const contentVersionLinkSet = useSalesChannelGeneralLinkSet({
    contentUuid: salesChannelContentUuid,
  });
  const salesChannelOutLinkSet = useSalesChannelProductLinkSet({
    salesChannelUuid,
  });

  // const originalLinkSet = salesChannelUuid
  //   ? salesChannelOuterLinkSet
  //   : contentVersionLinkSet;
  const ecomList = [];
  const infoList = [];
  if (salesChannelMode === SalesChannelMode.ECOMMERCE) {
    ecomList.push(currentUuid);
  } else {
    infoList.push(currentUuid);
  }
  if (sisterMode === SalesChannelMode.ECOMMERCE) {
    ecomList.push(sisterUuid);
  } else {
    infoList.push(sisterUuid);
  }
  if (salesChannelContentUuid) {
    return handleOnContentVersionSection({
      selectedUuid,
      ecomList,
      presetScopeVariables,
      presetLinkTypeFilter,
      contentVersionLinkSet,
    });
  } else {
    return handleOnSalesChannelSection({
      selectedUuid,
      ecomList,
      presetScopeVariables,
      salesChannelOutLinkSet,
      presetExcludeLinkType,
      presetLinkTypeFilter,
    });
  }
};

const handleOnSalesChannelSection = ({
  //目前应用到的只有Exclude
  selectedUuid,
  ecomList,
  presetScopeVariables,
  salesChannelOutLinkSet,
  presetExcludeLinkType,
  presetLinkTypeFilter,
}) => {
  const { scopeVariables, linkTypeFilter } = salesChannelOutLinkSet;
  if (ecomList.includes(selectedUuid)) {
    return {
      scopeVariables: presetScopeVariables || scopeVariables,
      linkTypeFilter: presetLinkTypeFilter || linkTypeFilter,
      excludeLinkType: presetExcludeLinkType,
    };
  } else {
    if (presetLinkTypeFilter) {
      const filterLinkType = (presetLinkTypeFilter || []).filter((i) =>
        infoSiteLinkType.includes(i),
      );
      return {
        scopeVariables: presetScopeVariables || scopeVariables,
        linkTypeFilter: filterLinkType,
        excludeLinkType: presetExcludeLinkType,
      };
    } else {
      return {
        scopeVariables: presetScopeVariables || scopeVariables,
        linkTypeFilter: infoSiteLinkType,
        excludeLinkType: presetExcludeLinkType,
      };
    }
  }
};
const handleOnContentVersionSection = ({
  selectedUuid,
  ecomList,
  presetScopeVariables,
  presetLinkTypeFilter,
  contentVersionLinkSet,
}) => {
  const { selectedLinkType, scopeVariables } = contentVersionLinkSet;

  if (ecomList.includes(selectedUuid)) {
    return {
      scopeVariables: presetScopeVariables || scopeVariables,
      linkTypeFilter: presetLinkTypeFilter || selectedLinkType,
    };
  } else {
    if (presetLinkTypeFilter) {
      const filterLinkType = (presetLinkTypeFilter || []).filter((i) =>
        infoSiteLinkType.includes(i),
      );
      return {
        scopeVariables: presetScopeVariables || scopeVariables,
        linkTypeFilter: filterLinkType,
      };
    } else {
      return {
        scopeVariables: presetScopeVariables || scopeVariables,
        linkTypeFilter: infoSiteLinkType,
      };
    }
  }
};
export {
  useSalesChannelGeneralLinkSet,
  useSalesChannelMiniProgramLinkSet,
  useSalesChannelProductLinkSet,
  checkIsInternal,
  useContentVersionLinkModuleWithSalesChannelMode,
};
